import { Country } from './country.model';
import { Relationship } from './relationship.model';

export class ContactPerson {
    cpeFirstName: string;
    cpeLastName: string;
    cpeMaidenName: string;
    cpeGender: any;
    cpePhoneNumber = '';
    cpeEmail = '';
    cpeRelationship: Relationship;
    cpeAddress: string;
    cpeCity: string;
    cpeCountry: Country;
    cpeRemarks: string;
    cpeSharePrivateInformation :boolean
}